import { render, staticRenderFns } from "./LogisticsPurchasing.vue?vue&type=template&id=29a06ac2"
import script from "./LogisticsPurchasing.vue?vue&type=script&lang=js"
export * from "./LogisticsPurchasing.vue?vue&type=script&lang=js"
import style0 from "./LogisticsPurchasing.vue?vue&type=style&index=0&id=29a06ac2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports